import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { Box, Button, Header, Text, TextInput } from '~/atomic';
import { useAppDispatch } from '~/store';
import { requestPasswordReset } from '~/store/recovery/thunks';

interface FormData {
  email: string;
}

export default function EmailView() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<FormData>({ defaultValues: { email: '' } });

  const onSubmit = async ({ email }: FormData) => {
    const ok = await dispatch(requestPasswordReset(email)).unwrap();
    if (ok) navigate('/auth/recovery/pin');
  };

  return (
    <div className="min-h-screen bg-intense-01 flex flex-col">
      <Header title="Recuperar senha" />
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex-1 w-full xl:max-w-[440px] mx-auto px-small py-medium flex flex-col gap-medium"
      >
        <Box>
          <Text className="text-headingH1 color-complement-01" as="h1">
            Esqueceu sua senha?
          </Text>
          <Text className="mt-quark text-bodyMD color-intense-06">
            Informe seu e-mail para receber instruções de recuperação.
          </Text>
        </Box>
        <TextInput
          control={control}
          name="email"
          icon="icon-email"
          placeholder="E-mail"
          keyboardType="email-address"
          mask="email"
        />
        <Button
          type="submit"
          fullWidth
          loading={isSubmitting}
          text="Enviar instruções"
          rightIcon="icon-arrow-right"
        />
      </form>
    </div>
  );
}
